import React from "react";

const DetailsFooter = () => {
  return (
      <section className='px-0 px-xl-3 py-md-5 py-3 d-flex justify-content-end'>
          <div className='d-block d-md-flex gap-3'>
  <div style={{borderTopLeftRadius:'52px', borderBottomLeftRadius:'52px', width:'240px',height:'', border:'1px solid #EDE9EA'}} className='p-1 mb-3'>
<div className="row g-4" >
   
   <div  className="col-12 ">
     <div className="d-flex align-items-center gap-3 rounded-3 ">
       <div className="flex-shrink-0">
       <i className="bi bi-whatsapp p-2" style={{border:'1px solid #EDE9EA', borderRadius:'50%'}}></i>
       </div>
       <div className="flex-grow-1">
         <div className="">
         <a href='https://chat.whatsapp.com/LQMW9mgRWN2L3LlO8UXFAo' target="_blank"  
    rel="noopener noreferrer"  style={{textDecoration:'none'}}>
           <p className="mb-0 text-dark" style={{fontWeight:'600'}}>Chat on Whatsapp</p>
           <p className="text-truncate text-decoration-underline mb-0" style={{color:'#9CA3AF'}}>+2349167682871</p>
           </a>
         </div>
       </div>
     </div>
   </div>
 
</div>
</div>


</div></section>
  );
};

export default DetailsFooter;
